import { render, staticRenderFns } from "./ECN2025.vue?vue&type=template&id=085efe4e&scoped=true"
import script from "./ECN2025.vue?vue&type=script&lang=js"
export * from "./ECN2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085efe4e",
  null
  
)

export default component.exports